module.exports = __webpack_public_path__ + "img/quest_icon_0071_food2.c38602bd.png";